import { useEffect, useMemo, useState } from 'react';

import { useHandlePaymentMethod } from './hooks/useHandlePaymentMethod';

import { Button, Dropdown, Loader } from '@/components';
import { useIsDesktop } from '@/hooks/useIsDesktop';
import usePinsAccount from '@/hooks/usePinsAccount';
import { useGetRechargeAmounts } from '@/modules/my-account/hooks/useMyAccount';
import { SelectValue } from '@/types';
import { formatNumberToLocale } from '@/utils';

export const LoadWallet = () => {
  const { data: dataAmounts, isLoading } = useGetRechargeAmounts();
  const { isDesktop } = useIsDesktop();
  const { handlePaymentMethod } = useHandlePaymentMethod();
  const { pinsData } = usePinsAccount();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const [selectedValue, setSelectedValue] = useState<SelectValue>({
    label: '',
    value: 0,
  });

  useEffect(() => {
    if (dataAmounts?.estado && dataAmounts.montosValidos) {
      const comboValues = dataAmounts.montosValidos.filter(
        (elem) => elem.selected
      )[0]?.monto;
      setSelectedValue({
        label: formatNumberToLocale(
          pinsData.moneyToWallet?.toString() || comboValues?.toString() || ''
        ),
        value: pinsData.moneyToWallet || comboValues || 0,
      });
    }
  }, [dataAmounts, pinsData.moneyToWallet]);

  const options = useMemo(() => {
    return (
      (dataAmounts?.estado &&
        dataAmounts.montosValidos &&
        dataAmounts.montosValidos.map((amount) => ({
          label: formatNumberToLocale(amount.monto),
          value: amount.monto,
        }))) ||
      []
    );
  }, [dataAmounts]);

  return (
    <div
      className={`relative ${
        isDropdownOpen ? 'max-md:h-[450px]' : 'max-md:h-[240px]'
      }`}
    >
      <Loader isVisible={isLoading} />
      <div
        className={`
        ${
          !isDesktop
            ? 'absolute inset-x-0 top-0 bottom-[60px] overflow-auto'
            : ''
        }`}
      >
        <p className="text-center px-6 mt-3">
          Cargá saldo y luego convertilo en el pack de pines que más te
          convenga.
        </p>
        {!isLoading && (
          <div className="mt-3">
            <Dropdown
              className="transition-all duration-300"
              label="Importe"
              options={[...options]}
              placement={'bottom'}
              selected={selectedValue}
              withFloat={isDesktop}
              onChange={(value) => setSelectedValue(value)}
              onOpenStateChange={(isOpen) => {
                setIsDropdownOpen(isOpen);
              }}
            />
          </div>
        )}
      </div>
      <div
        className={`${!isDesktop ? 'absolute inset-x-0 bottom-0 p-4' : 'mt-4'}`}
      >
        <Button
          className="w-full"
          type="button"
          variant="primary"
          onClick={() => {
            handlePaymentMethod({
              product: undefined,
              moneyToWallet: selectedValue.value,
            });
          }}
        >
          Continuar
        </Button>
      </div>
    </div>
  );
};
